module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp2-e59c22e2a3fbcd4e5575ebbe2aaf38aa.jpg";